import { QueryObserverOptions, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '@api/messages';
import { CommentDTO } from '../dto/CommentDTO';
import { getCommentsByUploadId } from '../api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<CommentDTO[]>, 'enabled'>;

export default function useGetComments(id: number, options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery(['comments', id], () => getCommentsByUploadId(id), {
    onError: error => {
      errorMessage({
        title: t('error.fetching.comments'),
        message: null,
        error,
      });
    },
    ...options,
  });

  return { comments: data, isFetching };
}
